export default "__VITE_ASSET__CvlVzJZs__"